<template>
<el-dialog title="Brands" :visible.sync="dialogTableVisible" style="height: 1000px;" width="75%">
    <div class="mt-n5 mb-3">
        <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable class="mb-2"></el-input>
        <el-button type="primary" @click="addBrand">Add</el-button>
        <el-button type="primary" @click="onLoadBrands">Refresh</el-button>
    </div>
    <e-table :data="items" :total="items.length" :headers="headers" :height="400" :loading="loading" :search="search">
        <template #actions="{scope}">
            <el-button class="mr-2" type="warning" @click.native="editBrand(scope.row)">
                <i class="el-icon-edit"></i>
            </el-button>
            <el-popconfirm title="Are you sure to delete this?" @onConfirm="deleteBrand(scope.row)" confirmButtonText="Yes" cancelButtonText="Cancel">
                <el-button slot="reference" type="danger">
                    <i class="el-icon-delete"></i>
                </el-button>
            </el-popconfirm>
        </template>
    </e-table>

    <el-dialog :title="`${form.title} Brand`" :visible.sync="form.visible" width="500px;" :append-to-body="true">
        <el-form :model="brandForm" ref="brandForm" label-position="left" label-width="100px">
            <el-form-item size="small" prop="brand" label="Brand">
                <el-input v-model="form.brand" clearable style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item size="small" prop="vendor" label="Vendor">
                <el-input v-model="form.vendor" clearable style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item size="small" prop="searchTerm" label="Search Term">
                <el-input v-model="form.searchTerm" clearable style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item size="small" prop="netTerm" label="Net Term">
                <el-input v-model="form.netTerm" clearable style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item size="small" prop="segment" label="Segment">
                <el-select v-model="form.segment" clearable style="width:100%;">
                    <el-option v-for="(brand, index) in ['Active','Fashion','Outdoor','Work']" :key="index" :value="brand">{{brand}}</el-option>
                </el-select>
            </el-form-item>
            <el-form-item size="small">
                <el-button type="primary" style="width: 100px;" plain @click="dialogTableVisible = false">Cancel</el-button>
                <el-button type="primary" style="width: 100px;" @click="onSubmit" :disabled="loading" :loading="form.loading">{{form.title}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</el-dialog>
</template>

<script>
export default {
    data: () => ({
        brandForm: null,
        form: {
            loading: false,
            visible: false,
            title: 'Add',
            id: 0,
            brand: '',
            vendor: '',
            searchTerm: '',
            netTerm: '',
            segment: ''
        },
        search: '',
        loading: false,
        headers: [{
                text: "Brand",
                value: 'brand',
                sortable: true
            },
            {
                text: "Vendor",
                value: 'vendor',
                sortable: true
            },
            {
                text: "Email Search Team",
                value: 'searchTerm',
                sortable: true
            },
            {
                text: "Term",
                value: 'netTerm',
                sortable: true
            },
            {
                text: "Segment",
                value: 'segment',
                sortable: true
            },
            {
                text: 'Actions',
                align: 'center',
                alignHeader: 'center'
            }
        ],
        items: [],
        dialogTableVisible: false
    }),
    created() {
        this.onLoadBrands()
    },
    methods: {
        onOpenDialog() {
            this.dialogTableVisible = !this.dialogTableVisible
        },
        async onLoadBrands() {
            try {
                let response = await this.$http.get('/edi/brands')
                this.items = response.data
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: error.data.message
                })
            }
        },
        addBrand() {
            this.form.title = "Add"
            this.form.visible = true

            this.form.id = ''
            this.form.brand = ''
            this.form.vendor = ''
            this.form.searchTerm = ''
            this.form.netTerm = ''
            this.form.segment = ''
        },
        async deleteBrand(item) {
            try {
                let response = await this.$http.delete(`/edi/brands/${item.id}`);
                this.$message({
                    type: "success",
                    message: response.data.msg
                });
            } catch (error) {
                this.$message({
                    type: "error",
                    message: error.data.msg
                });
            } finally {
                this.form.visible = false
                this.onLoadBrands()
            }
        },
        editBrand(item) {
            this.form.title = "Edit"
            this.form.visible = true

            this.form.id = item.id
            this.form.brand = item.brand
            this.form.vendor = item.vendor
            this.form.searchTerm = item.searchTerm
            this.form.netTerm = item.netTerm
            this.form.segment = item.segment
        },
        async onSubmit() {
            let { title, id, brand, vendor, searchTerm, netTerm, segment } = this.form;
            let data = { brand, vendor, searchTerm, netTerm, segment };

            try {
                this.form.loading = true
                let response;
                if (title === 'Add') {
                    response = await this.$http.post('/edi/brands', data);
                } else if (title === 'Edit') {
                    response = await this.$http.put(`/edi/brands/${id}`, data);
                }
                this.$message({
                    type: "success",
                    message: response.data.msg
                });
            } catch (error) {
                this.$message({
                    type: "error",
                    message: error.data.msg
                });
            } finally {
                this.form.loading = false
                this.form.visible = false
                this.onLoadBrands()
            }
        }
    }
}
</script>
